const authConfig = {
  loginPath: '/auth/familysearch/login',
  logoutPath: '/auth/logout',
  registerPath: '/register/',
}

export default authConfig
